import "./ServiceHero.css";
import { ArrowRight } from "lucide-react";
import heroBg from "../assets/HeroService.png";

const ServiceHero = ({ title, subtitle }) => {

  const handleConsultation = () => {
    const phoneNumber = "919653304639";

    const message =
      `Hi, I'd like to know more about your ${title} services and discuss my project.`;

    window.open(
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <section
      className="webdev-hero"
      style={{ backgroundImage: `url(${heroBg})` }}
    >

      <div className="webdev-hero-overlay"></div>

      <div className="webdev-hero-content">

        <span className="webdev-badge">
          SHIRDHANKAR TECHNOLOGIES
        </span>

        <h1>{title}</h1>

        <p>{subtitle}</p>

        <div className="webdev-buttons">

          <a href="#offers" className="primary-btn">
            View Packages
          </a>

          <button
            className="secondary-btn"
            onClick={handleConsultation}
          >
            Schedule Consultation
            <ArrowRight size={18} />
          </button>

        </div>

      </div>

    </section>
  );
};

export default ServiceHero;